import SpinwheelVerification from '../../../../onboarding/components/spinwheel/SpinwheelVerification';

export default function SpinwheelVerificationScreen() {
    return <SpinwheelVerification />;
}
